import { tableFrCATranslations } from "../components/table/_lang/fr-CA";
import { editableFieldFrCATranslations } from "../controls/editable-field/_lang/fr-CA";
import { fileFrCATranslations } from "../controls/file/_lang/fr-CA";
import { taggedInputFrCATranslations } from "../controls/tagged-input/_lang/fr-CA";
import { draftFrCATranslations } from "../hooks/_lang/fr-CA";
import type { RayaLucariaTranslationKey } from "./en-US";

export const rayaLucariaFrCA: Record<RayaLucariaTranslationKey, string> = {
  ...tableFrCATranslations,
  ...draftFrCATranslations,
  ...editableFieldFrCATranslations,
  ...fileFrCATranslations,
  ...taggedInputFrCATranslations,
  apply: "Appliquer",
  cancel: "Annuler",
  close: "Fermer",
  dismiss: "Fermer",
  saving: "Enregistrement...",
  saved: "Enregistré",
  clear: "Effacer",
  confirm: "Confirmer",
  filter: "Filtrer",
  filterValue: "Valeur du filtre",
  expandMenu: "Développer le menu",
  collapseMenu: "Réduire le menu",
  openMenu: "Ouvrir le menu",
  mainNavigation: "Navigation principale",
  secondaryNavigation: "Navigation secondaire",
  navigationMenu: "Menu de navigation",
  aboutField: "À propos de {{label}}",
  moreInformation: "Plus d'information",
  passcodeLegend: "Saisissez le code de {{count}} caractères",
  passcodeCharacter: "Caractère {{index}} sur {{count}}",
  passcodeIncomplete: "Saisissez les {{count}} caractères",
};
